<template>
    <article class="execution-step">
        <h3 class="execution-step__title">{{ title }}</h3>
        <p class="execution-step__description">{{ description }}</p>
        <a v-if="link && link.url" :href="link.url" class="execution-step__link" target="_blank" rel="noopener noreferrer">
            {{ link.text }}
        </a>
    </article>
</template>

<script>
export default {
    name: 'CurrentOffer',

    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        link: {
            type: Object,
            required: false,
            default: null
        },
    },
    computed: {
        orderStepString() {
            return this.orderNumber < 10 ? '0' + this.orderNumber : this.orderNumber;
        }
    }
}
</script>

<style scoped lang="scss">
.execution-step {
    $border-radius-desktop: $border-radius-default;
    $padding-desktop: $gap-medium;

    overflow: hidden;

    height: 100%;
    padding: rem($padding-desktop);

    border-radius: rem($border-radius-desktop);
    background-color: $color-card-background-primary;

    &__header {
        @include flex-space-between;

        &-icon {
            color: $primary;
        }
    }

    &__order-number {
        @include text-xl;

        color: $color-text-muted-high;

        @media #{$screen-big} {
            font-size: rem($font-size-large);
        }
    }

    &__title {
        @include text-medium($font-weight-bold, $line-height-large);

        margin: rem($gap-normal) 0;

        @media #{$screen-big} {
            font-size: rem($font-size-normal);
        }
    }

    &__description {
        height: 110px;
        @include text-normal;

        @media #{$screen-big} {
            font-size: rem($font-size-small);
        }
    }
    &__link {
        @include text-normal($font-weight-bold, $line-height-large);
        color: $bondi-blue;
    }
}
</style>